module.exports = __webpack_public_path__ + "img/cloudPurchase_recommend.94da961c.png";